import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import Location from '../../components/location'
import {
  getEnabledConciergeLocations,
  getEnabledConciergeLocationsKey,
} from '../../api-client/listing'
import useLocation from '../../hooks/use-location'
import getClosestLocation from '../../utils/get-closest-location'
import { LinkButtonGroup } from '../../components/button'

export default function LocationInfo() {
  const [userLocation] = useLocation()

  const { data: locations = [], isFetching: locationsFetching } = useQuery({
    queryKey: getEnabledConciergeLocationsKey,
    queryFn: getEnabledConciergeLocations,
    keepPreviousData: true,
  })

  const location = useMemo(() => {
    if (!!locationsFetching) {
      console.log('locations fetching')
      return null
    }

    if (!locations) {
      console.log('locations is null')
      return null
    }
    if (locations.length === 0) {
      console.log('locations is empty')
      return null
    }

    let currentLocation = getClosestLocation(locations, userLocation, 'springdale')
    if (!currentLocation) {
      console.log('defaulting to first location in list')
      currentLocation = locations[0] // should be springdale
    }

    return currentLocation
  }, [locations, userLocation, locationsFetching])

  return (
    <div className='locationContainer'>
      <div className='headings'>
        <h2>Concierge location</h2>
        <p>
          The map below will show you the concierge location that is closest to you. Concierge
          locations are where sellers drop off the vehicle, and where buyers can pick them up. Most
          concierge locations have other services available such as inspections, cleaning and
          aftermarket options for your new vehicle.
        </p>
      </div>

      <div className='mapContainer'>
        {!!location && (
          <div>
            <div className='locationLinks'>
              <LinkButtonGroup
                name='conciergeLocationName'
                label='Find a concierge location'
                value={location.value}
                options={locations}
                buttonSize='auto'
              />
              <br />
            </div>

            <Location
              lat={location.lat}
              lng={location.lng}
              title={location.title}
              allLocations={locations}
            />
          </div>
        )}
      </div>

      <style jsx>{`
        .locationContainer {
          background-color: var(--primary-bg-color);
          
          .headings {
            padding: 0 1.2rem;

            h2 {
              text-align: center;
              font-size: 5.4rem;
            }

            p {
              max-width: 99.6rem;
              margin: 1.8rem auto 2rem;
              text-align: center;
              font-size: 1.8rem;
            }
          }
        }

        .location {
          width: 80%;

          h3 {
            margin: 0 0 3.7rem;
            text-align: center;
          }
        }

        .mapContainer {
          position: relative;
          max-width: 134.3rem;
          margin: 0 auto;
          padding: 0 1.2rem;
          border-radius: 1rem;
          overflow: hidden;
        }

        @media (max-width: 1024px) {
          .locationContainer {
            .headings {
              margin: 0;

              h2 {
                font-size: 2rem;
              }

              p {
                max-width: 50rem;
                margin: 0.6rem auto 1.7rem;
                font-size: 1.4rem;
              }
            }
          }

          .location {
            width: 100%;

            h3 {
              margin: 0 0 2.2rem;
            }
          }

          .mapContainer {
            position: relative;
            bottom: 0;
            padding: 0;
            border-radius: 0;

            .locationLinks {
              padding: 0 1.2rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
